export default () => {
    const hamburger = document.querySelector(".navbar-toggle");
    const navbarMobile = document.querySelector(".navbar-mobile");
    const body = document.body;

    hamburger.addEventListener("click" , function() {
        hamburger.classList.toggle("toggle--active");
        navbarMobile.classList.toggle("navbar-mobile--hide");
        body.classList.toggle("body-block");
    });

}
